import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

const ClassUtilizationChart = ({ data }) => {
  const COLORS = [
    'var(--color-primary)',
    'var(--color-success)',
    'var(--color-accent)',
    'var(--color-warning)',
    'var(--color-error)'
  ];

  return (
    <div className="card">
      <h3 className="text-xl font-heading font-semibold text-foreground mb-6">
        Class Utilization Rate
      </h3>
      <div className="w-full h-80" aria-label="Class Utilization Pie Chart">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={({ name, percent }) => `${name}: ${(percent * 100)?.toFixed(0)}%`}
              outerRadius={100}
              fill="var(--color-primary)"
              dataKey="value"
            >
              {data?.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS?.[index % COLORS?.length]} />
              ))}
            </Pie>
            <Tooltip 
              contentStyle={{ 
                backgroundColor: 'var(--color-card)',
                border: '1px solid var(--color-border)',
                borderRadius: '12px',
                padding: '12px'
              }}
              formatter={(value) => `${value}%`}
            />
            <Legend 
              verticalAlign="bottom" 
              height={36}
              iconType="circle"
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default ClassUtilizationChart;